
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { TextStyleCategory, TextStyleColor, TextStyleSize, TextStyleVariant } from '@sirius/typography';
import { textStyleClass, textStyleColorClass } from '@sirius/typography';

@Component({
    selector: 'sirius-label',
    template: `<label [for]="for" [class]="labelClass">
        <ng-content></ng-content>
    </label>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./label.component.scss'],
})
export class LabelComponent {
    @Input() for = '';
    @Input() textStyle: TextStyleCategory = 'system';
    @Input() textStyleSize: TextStyleSize = 'l';
    @Input() textStyleVariant: TextStyleVariant = 'default';
    @Input() textStyleColor?: TextStyleColor;

    /** Typography utility classes for the label (ADR 0001). */
    get labelClass(): string {
        const base = textStyleClass(this.textStyle, this.textStyleSize, this.textStyleVariant);
        return this.textStyleColor ? `${base} ${textStyleColorClass(this.textStyleColor)}` : base;
    }
}
